import { config as yandex } from "./yandex";
import { config as yandexCom } from "./yandex_com";
import { config as yango } from "./yango";

const getConfig = () => {
  if (/\.yandex\.(ru|by|kg|kz|uz)$/.test(window.location.hostname)) {
    return yandex;
  }
  if (/\.yandex\.com$/.test(window.location.hostname)) {
    return yandexCom;
  }
  if (/\.yango\.com$/.test(window.location.hostname)) {
    return yango;
  }
  throw Error("no app config for current hostname");
};

export const config = getConfig();
